<template>
  <div class="fill-in-blank">
    <input 
      type="text" 
      class="form-control mb-2" 
      v-model="userAnswer"
      placeholder="Vul je antwoord in..."
      @input="updateAnswer"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps({
  question: {
    type: Object,
    required: true
  },
  selectedAnswer: {
    type: [String, null],
    default: null
  }
});

const emit = defineEmits(['select-answer']);
const userAnswer = ref('');

watch(() => props.selectedAnswer, (newVal) => {
  if (newVal !== null && typeof newVal === 'string') {
    userAnswer.value = newVal;
  }
}, { immediate: true });

function updateAnswer() {
  emit('select-answer', userAnswer.value);
}
</script>
